module.exports = __webpack_public_path__ + "static/media/filterIconDesktop.81109c33.svg";